import axios from 'axios'
import utils from './utils'
import url from './url'
import $ from 'jquery'

const imageSize = {
  'lg': '?x-oss-process=image/resize,m_lfit,w_720,limit_0/auto-orient,1',
  'md': '?x-oss-process=image/resize,m_lfit,w_471,limit_0/auto-orient,1',
  'sm': '?x-oss-process=image/resize,m_lfit,w_160,limit_0/auto-orient,1',
  'o': '?x-oss-process=image/auto-orient,1'
}

// 获取图片宽度 高度
const _getImageWidthAndHeight = (imgUrl) => {
  imgUrl = imgUrl || ''
  if (imgUrl.indexOf('newaircloud') > 0) {
    var _getImgInfo = imgUrl.indexOf('@!') > -1 ? imgUrl.split('@!')[0] : imgUrl.indexOf('?') > -1 ? imgUrl.split('?')[0] : imgUrl
    var _o = {}
    try {
      $.ajax({
        url: _getImgInfo.replace('http://', 'https://') + '?x-oss-process=image/info',
        async: false,
        type: 'GET',
        dataType: 'json',
        success: function (result, status, xhr) {
          // console.log('_getImageWidthAndHeight: ', result, status)
          // 图片宽
          _o.w = result.ImageWidth.value ? result.ImageWidth.value : ''
          // 图片高
          _o.h = result.ImageHeight.value ? result.ImageHeight.value : ''
          // 图片宽高比
          _o.r = _o.w / _o.h
        },
        error: function (xhr, status, error) {
          console.log('_getImageWidthAndHeight -- error : ', xhr, status, error)
        }
      })
    } catch (e) {

    }
    return _o
  }
}
// 处理图片后缀参数
const handleImgScaleUrl = function (item, imgScale, other) {
  // 处理图片的显示比例及替换为https
  // item: 图片地址 ; imgScale: 图片显示比例后缀
  item = item || ''
  // eslint-disable-next-line eqeqeq
  item == 'undefined' ? item = '' : ''
  // eslint-disable-next-line eqeqeq
  if (!item || item.indexOf('newaircloud') === -1 || /(\.gif)/gi.test(item) && imgScale == 'o') return item
  item = item.replace(/http:\/\/img\.newaircloud\.com/gi, 'https://oss.newaircloud.com')
  // imgScale = imgScale || '@!sm'
  imgScale = other && imgScale || imgScale && imageSize[imgScale] || imageSize.md
  item = item.indexOf('@!') > -1 ? item.replace('http://', 'https://') : item.indexOf('x-oss-process') > -1 ? item.replace('http://', 'https://') : item.replace('http://', 'https://') + imgScale
  return item
}

// 处理图片大小
const parseImageStyle = (items, config) => {
  if (!items) return ''
  let imgMore = ''
  let imgOne = ''
  let imgOriginal = ''
  if (config && Object.keys(config).length > 0) {
    imgMore = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_size_more || '') + (config.img_param_waterMark || '') : ''
    imgOne = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_size_one || '') + (config.img_param_waterMark || '') : ''
    imgOriginal = config.img_param_global ? '?' + (config.img_param_global || '') + (config.img_param_format || '') + (config.img_param_waterMark || '') : ''
  }
  var curList = []
  // eslint-disable-next-line no-unused-vars,one-var
  var _w = 250, _y = 180, _x = 1, _l = 6,
    _clientWidth = utils.clientWidth || 0,
    _clientHeight = utils.clientHeight || 0
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth
  if (deviceWidth >= 750) {
    deviceWidth = 750
  }
  if (deviceWidth <= 320) {
    deviceWidth = 320
  }
  if (!utils.browser().mobile) {
    _clientWidth = 414
    deviceWidth = 414
  }
  deviceWidth = deviceWidth / 7.5
  for (var i = 0; i < items.length; i++) {
    var cur = items[i]
    cur._picsLength = 0
    cur._videosLength = 0
    cur._clientWidth = _clientWidth || 0
    cur._clientHeight = _clientHeight || 0
    if (cur && cur.attUrls && Object.keys(cur.attUrls).length > 0) {
      var curAtt = cur.attUrls
      if (curAtt.pics && curAtt.pics.length > 0) {
        // if (utils.clientWidth !== 375) {
        //   _w = 250 * utils.clientWidth / 375
        // }
        // if (utils.clientHeight !== 667) {
        //   _y = 180 * utils.clientHeight / 667
        // }

        cur._picsLength = curAtt.pics.length
        var _curWidthHeight = _getImageWidthAndHeight(curAtt.pics[0] && curAtt.pics[0].url)
        _x = _curWidthHeight.r
        if (cur._picsLength > 1) {
          _w = _clientWidth - (0.66 * deviceWidth + 0.3 * deviceWidth + 0.3 * deviceWidth)
          _y = 100
          _x = 1
          _l = 0.12 * deviceWidth
          _y = (_w - 2 * _l) / 3
          cur._picsWidth = (_w - 2 * _l) / 3 + 'px'
          cur._picsHeight = (_w - 2 * _l) / 3 + 'px'
        } else {
          _w = 250
          _y = 180
          _l = 6
          if (_x > 3) {
            cur._picsWidth = _w / 50 + 'rem'
            cur._picsHeight = (_w - 2 * _l) / 3 / 50 + 'rem'
          } else if (_x >= 1 && _x <= 3) {
            cur._picsWidth = _y / 50 + 'rem'
            cur._picsHeight = _y / _x / 50 + 'rem'
          } else if (_x >= (1 / 3) && _x <= 1) {
            cur._picsWidth = _y * _x / 50 + 'rem'
            cur._picsHeight = _y / 50 + 'rem'
          } else if (_x < (1 / 3)) {
            cur._picsWidth = _y / 3 / 50 + 'rem'
            cur._picsHeight = _y / 50 + 'rem'
          }
          //
        }

        for (var n = 0; n < curAtt.pics.length; n++) {
          curAtt.pics[n] && curAtt.pics[n].url ? (curAtt.pics[n].urlOriginal = handleImgScaleUrl(curAtt.pics[n].url, imgOriginal, 1)) && (curAtt.pics[n].url = handleImgScaleUrl(curAtt.pics[n].url, curAtt.pics.length === 1 && imgOne || imgMore, 1)) : ''
        }
      }
      //
      if (curAtt.videos && curAtt.videos.length > 0) {
        cur._videosLength = curAtt.videos.length
        cur._videosHeight = ((cur._clientWidth / 50 - 0.6 - 0.66) / 1.77777778) && (((cur._clientWidth / 50 - 0.6 - 0.66) / 1.77777778) + 'rem') || 'auto'
      }
      // 处理视频封面图 为 @!md
      if (curAtt.videoPics && curAtt.videoPics.length > 0) {
        curAtt.videoPics && curAtt.videoPics[0] && curAtt.videoPics[0].url ? curAtt.videoPics[0].url = handleImgScaleUrl(curAtt.videoPics[0].url) : ''
      }
    }

    // 处理头象为 @!sm
    if (cur.faceUrl && cur.faceUrl.length > 0) {
      cur.faceUrl = handleImgScaleUrl(cur.faceUrl, 'sm')
    }

    if (cur && cur.discussID && (localStorage.getItem('topicDiscussPraise') || '').indexOf(cur.discussID) > -1) {
      cur.curClass = 'news_comment_praise_img_active'
    } else {
      cur.curClass = 'news_comment_praise_img_' + cur.discussID
    }
    curList.push(cur)
  }
  return curList || ''
}

// 处理请求参数
let requestHeader = async (data, n, str) => {
  let _sid = data.sid
  var _a = ''
  if (!n) {
    _a = await getToken(data)
  }
  str = str || ''
  // eslint-disable-next-line one-var
  var _v = '1.0',
    _d = utils.getUrlParam('deviceID') ? utils.getUrlParam('deviceID') : utils.SHA_UUID_MD.UUID(),
    _s = 1,
    _t = utils.SHA_UUID_MD.MD5(utils.SHA_UUID_MD.MD5(_sid)),
    _ti = new Date().myUTCFormat(),
    _n = utils.SHA_UUID_MD.UUID()

  var _si = utils.SHA_UUID_MD.HEX_SHA1(_t + _n + _ti + _v + str + _d + _s + _a)
  var _o = {}
  _o.data = {
    sid: _sid,
    deviceID: _d,
    source: _s,
    sign: _si
  }

  if (data || Object.keys(data).length > 0) {
    Object.assign(_o.data, data)
  }
  _o.headers = {
    timestamp: _ti,
    tenant: _t,
    version: _v,
    nonce: _n
    // 'Content-Type': 'application/x-www-form-urlencoded',
  }
  if (_a) {
    _o.headers.authtoken = _a
  }
  return _o
}

let getToken = async (d) => {
  var _authtoken = ''
  // eslint-disable-next-line no-unused-vars
  const _getToken = async (d, callback) => {
    _getToken.retry = _getToken.retry || 0
    if (_getToken.retry > 3) {
      alert('网络有些问题，请稍后再试!')
      return
    }
    let _h = await requestHeader(d, 1)
    _getToken.retry++
    await axios.post(url._TOKEN, _h.data
      , {
        headers: _h.headers
      }).then(({data}) => {
      // eslint-disable-next-line eqeqeq
        if (typeof data !== 'undefined' && data.success == 1 && data.authtoken && data.authtoken.length > 0) {
          localStorage.setItem('localToData', JSON.stringify({
            timestamp: _h.headers.timestamp,
            authtoken: data.authtoken,
            expires_in: data.expires_in,
            sid: d.sid,
            domain: window.location.origin
          }))
          _getToken.retry = 0
          typeof callback === 'function' && callback(data.authtoken)
        } else {
          _getToken.retry = 3
          if (data && /请校正系统时间/.test(data.msg)) {
            alert(data.msg)
          } else {
          // _getToken(d)
            console.log(data.msg)
          }
        }
      }).catch((err) => {
        _getToken.retry = 0
        console.log('_getToken-err', err)
      })
  }

  var localToData = localStorage.getItem('localToData')
  if (localToData != null) {
    localToData = JSON.parse(localStorage.getItem('localToData'))
    // eslint-disable-next-line eqeqeq
    if (localToData && localToData.timestamp && utils.timeComparison(localToData.timestamp, localToData.expires_in) && localToData.domain == window.location.origin && localToData.sid == d.sid) {
      return localToData.authtoken && localToData.authtoken.length > 0 ? localToData.authtoken : ''
    } else {
      await _getToken(d, function (res) {
        _authtoken = res
      })
    }
  } else {
    await _getToken(d, function (res) {
      _authtoken = res
    })
  }
  return _authtoken || ''
}

let getAxios = async (url, param, type, str) => {
  getAxios[url] = getAxios[url] || 0
  if (getAxios[url] > 2) {
    getAxios[url] = 0
    // alert('网络有些问题，请稍后再试!!')
    return ''
  }
  const _p = await requestHeader(param, 0, str)
  getAxios[url]++
  return new Promise((resolve, reject) => {
    let _submitData = {
      url: url,
      headers: _p.headers
    }
    if (type) {
      _submitData.method = 'POST'
      _submitData.data = _p.data
    } else {
      _submitData.params = _p.data
    }
    axios(_submitData).then((res) => {
      if (res && res.data) {
        if (res.data.success || typeof res.data.success === 'undefined') {
          getAxios[url] = 0
          return resolve(res)
        } else if (!res.data.success && /(无效的签名)|(appToken无效)/.test(res.data.msg)) {
          if (getAxios.retry > 2) {
            getAxios[url] = 0
            return resolve(res)
          } else {
            localStorage.removeItem('localToData')
            getAxios(url, param, type, str)
          }
        }
      }
    }).catch((err) => {
      console.log('getAxios-err', err)
      getAxios[url] = 0
      return reject(err)
    })
  })
}

// 参与话题详情内容
const getTopicInfo = (param) => {
  return getAxios(url._GETTOPICINFO, param, '', '' + param.uid + param.topicID)
}

// app配置信息
const getConfig = (param) => {
  return getAxios(url._GETCONFIG, param)
}

// 点赞
const clickPraise = (param, n) => {
  var str = ''
  if (n) {
    str = param.uid + '' + param.discussID
  } else {
    str = param.id + '' + param.type + '' + param.eventType
  }
  return getAxios(n && url._DISCUSSPRAISE || url._SUBEVENT, param, 1, str)
}

// 参与详情热门评论
const getTopicDiscussContent = (param) => {
  return getAxios(url._GETTOPICDISCUSSCONTENT, param, '', '' + param.discussID)
}

// 参与详情热门评论
const getHotComments = (param) => {
  var str = ''
  str = param.userID + '' + param.rootID + '' + param.sourceType + param.lastFileID + '' + param.rowNumber
  return getAxios(url._GETHOTCOMMENTS, param, 0, str)
}
// 参与详情评论
const getComments = (param) => {
  var str = ''
  str = param.userID + '' + param.rootID + '' + param.sourceType + param.lastFileID + '' + param.rowNumber
  return getAxios(url._GETCOMMENTS, param, 0, str)
}

// 话题详情参与列表
const getDiscussList = (param) => {
  return getAxios(url._GETDISCUSSLIST, param, 0, '' + param.pageNum + '' + param.topicID)
}

// 话题参与详情评论提交
const submitComment = (param) => {
  var str = param.userID + encodeURIComponent(param.userName) + '' + param.rootID + param.parentID + param.sourceType + encodeURIComponent(param.topic) + param.articleType
  return getAxios(url._SUBMITCOMMENT, param, 1, str)
}

// 广告
const getTopicAdv = (param) => {
  return getAxios(url._GETTOPICADV, param, 0, '' + param.cid + param.uid)
}

export default ({
  parseImageStyle,
  handleImgScaleUrl,
  clickPraise,
  getConfig,
  getTopicDiscussContent,
  getHotComments,
  getComments,
  getDiscussList,
  getTopicInfo,
  submitComment,
  getTopicAdv
})



// WEBPACK FOOTER //
// ./src/tool/submit.js